import React from 'react';

const HongKong = (props: { width: number }) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 33 22"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>Hong Kong Flag</title>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fillRule="nonzero" id="hk">
          <polygon
            fill="#DE2910"
            id="Path"
            points="0 0 33 0 33 22 0 22"
          ></polygon>
          <g id="a" transform="translate(14.000000, 5.000000)">
            <path
              d="M2.32869903,5.92965169 C-1.75918447,4.4301236 0.0528932039,-0.19105618 3.96248544,0.0412247191 C3.17157282,0.394044944 3.05693204,1.05235955 3.50862136,1.66223596 C4.01440777,2.34502247 3.46201942,3.44362921 2.77829126,3.7105618 C1.65460194,4.14960674 1.42963107,5.32011236 2.32869903,5.92965169 Z"
              fill="#FFFFFF"
              id="Path"
            ></path>
            <path
              d="M2.10765049,2.59280899 L1.87774757,2.90608989 L1.79448544,2.54153933 L1.37976699,2.44853933 L1.7535534,2.26685393 L1.72749515,1.89610112 L2.04147573,2.14857303 L2.43976699,2.01229213 L2.26073786,2.34970787 L2.53262136,2.63639326 L2.10765049,2.59280899 Z M2.35184466,5.89075281 C1.85743689,5.67050562 1.45879612,5.21137079 1.28512621,4.66274157 C1.08648544,4.03341573 1.20073786,3.35679775 1.59902913,2.80752809 L1.51328155,2.76053933 C1.10007767,3.33117978 0.981514563,4.03277528 1.18761165,4.68593258 C1.3712233,5.26641573 1.7784466,5.73414607 2.3055534,5.96898876 L2.35184466,5.89075281 Z"
              fill="#DE2910"
              id="Shape"
            ></path>
          </g>
          <g
            id="a-link"
            transform="translate(19.246984, 9.897159) rotate(72.000000) translate(-19.246984, -9.897159) translate(17.246984, 6.397159)"
          >
            <g id="a" transform="translate(-0.000000, 0.000000)">
              <path
                d="M2.19868,6.45014333 C-1.66096333,4.81899 0.04994,-0.207826667 3.74124667,0.0448433333 C2.99449333,0.428633333 2.88625333,1.14473333 3.31272333,1.80814333 C3.79027,2.55086333 3.26872333,3.74590333 2.62317,4.03626667 C1.56222,4.51385 1.34981,5.7871 2.19868,6.45014333 Z"
                fill="#FFFFFF"
                id="Path"
              ></path>
              <path
                d="M1.98997333,2.8204 L1.77290667,3.16118 L1.69429333,2.76463 L1.30273,2.66346667 L1.65564667,2.46583333 L1.63104333,2.06253667 L1.92749333,2.33717 L2.30354667,2.18892667 L2.13451333,2.55596 L2.39121667,2.86781 L1.98997333,2.8204 Z M2.22053333,6.40783 C1.75373,6.16825 1.37734667,5.66881333 1.21337333,5.07202667 C1.02582333,4.38746 1.13369667,3.65145 1.50975,3.05396667 L1.42879,3.00285333 C1.03865667,3.62358333 0.926713333,4.38676333 1.12130333,5.09725333 C1.29466333,5.72869 1.67915,6.23747667 2.17682667,6.49293333 L2.22053333,6.40783 Z"
                fill="#DE2910"
                id="Shape"
              ></path>
            </g>
          </g>
          <g
            id="a-link"
            transform="translate(18.397729, 13.271740) rotate(144.000000) translate(-18.397729, -13.271740) translate(16.397729, 9.771740)"
          >
            <g id="a" transform="translate(-0.000000, 0.000000)">
              <path
                d="M2.19868,6.45014333 C-1.66096333,4.81899 0.04994,-0.207826667 3.74124667,0.0448433333 C2.99449333,0.428633333 2.88625333,1.14473333 3.31272333,1.80814333 C3.79027,2.55086333 3.26872333,3.74590333 2.62317,4.03626667 C1.56222,4.51385 1.34981,5.7871 2.19868,6.45014333 Z"
                fill="#FFFFFF"
                id="Path"
              ></path>
              <path
                d="M1.98997333,2.8204 L1.77290667,3.16118 L1.69429333,2.76463 L1.30273,2.66346667 L1.65564667,2.46583333 L1.63104333,2.06253667 L1.92749333,2.33717 L2.30354667,2.18892667 L2.13451333,2.55596 L2.39121667,2.86781 L1.98997333,2.8204 Z M2.22053333,6.40783 C1.75373,6.16825 1.37734667,5.66881333 1.21337333,5.07202667 C1.02582333,4.38746 1.13369667,3.65145 1.50975,3.05396667 L1.42879,3.00285333 C1.03865667,3.62358333 0.926713333,4.38676333 1.12130333,5.09725333 C1.29466333,5.72869 1.67915,6.23747667 2.17682667,6.49293333 L2.22053333,6.40783 Z"
                fill="#DE2910"
                id="Shape"
              ></path>
            </g>
          </g>
          <g
            id="a-link"
            transform="translate(14.925878, 13.506854) rotate(-144.000000) translate(-14.925878, -13.506854) translate(12.925878, 10.006854)"
          >
            <g id="a" transform="translate(0.000000, -0.000000)">
              <path
                d="M2.19868,6.45014333 C-1.66096333,4.81899 0.04994,-0.207826667 3.74124667,0.0448433333 C2.99449333,0.428633333 2.88625333,1.14473333 3.31272333,1.80814333 C3.79027,2.55086333 3.26872333,3.74590333 2.62317,4.03626667 C1.56222,4.51385 1.34981,5.7871 2.19868,6.45014333 Z"
                fill="#FFFFFF"
                id="Path"
              ></path>
              <path
                d="M1.98997333,2.8204 L1.77290667,3.16118 L1.69429333,2.76463 L1.30273,2.66346667 L1.65564667,2.46583333 L1.63104333,2.06253667 L1.92749333,2.33717 L2.30354667,2.18892667 L2.13451333,2.55596 L2.39121667,2.86781 L1.98997333,2.8204 Z M2.22053333,6.40783 C1.75373,6.16825 1.37734667,5.66881333 1.21337333,5.07202667 C1.02582333,4.38746 1.13369667,3.65145 1.50975,3.05396667 L1.42879,3.00285333 C1.03865667,3.62358333 0.926713333,4.38676333 1.12130333,5.09725333 C1.29466333,5.72869 1.67915,6.23747667 2.17682667,6.49293333 L2.22053333,6.40783 Z"
                fill="#DE2910"
                id="Shape"
              ></path>
            </g>
          </g>
          <g
            id="a-link"
            transform="translate(13.629410, 10.277581) rotate(-72.000000) translate(-13.629410, -10.277581) translate(11.629410, 6.777581)"
          >
            <g id="a" transform="translate(-0.000000, 0.000000)">
              <path
                d="M2.19868,6.45014333 C-1.66096333,4.81899 0.04994,-0.207826667 3.74124667,0.0448433333 C2.99449333,0.428633333 2.88625333,1.14473333 3.31272333,1.80814333 C3.79027,2.55086333 3.26872333,3.74590333 2.62317,4.03626667 C1.56222,4.51385 1.34981,5.7871 2.19868,6.45014333 Z"
                fill="#FFFFFF"
                id="Path"
              ></path>
              <path
                d="M1.98997333,2.8204 L1.77290667,3.16118 L1.69429333,2.76463 L1.30273,2.66346667 L1.65564667,2.46583333 L1.63104333,2.06253667 L1.92749333,2.33717 L2.30354667,2.18892667 L2.13451333,2.55596 L2.39121667,2.86781 L1.98997333,2.8204 Z M2.22053333,6.40783 C1.75373,6.16825 1.37734667,5.66881333 1.21337333,5.07202667 C1.02582333,4.38746 1.13369667,3.65145 1.50975,3.05396667 L1.42879,3.00285333 C1.03865667,3.62358333 0.926713333,4.38676333 1.12130333,5.09725333 C1.29466333,5.72869 1.67915,6.23747667 2.17682667,6.49293333 L2.22053333,6.40783 Z"
                fill="#DE2910"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default HongKong;
